import { useCallback, useMemo } from 'react';
import { SortModeEnum } from 'components/filtering/types/SortObject';
import { FilterValue } from 'components/filtering/types/FilterObject';
import { BaseGridHeaderProps } from 'components/filtering/base-grid-header/BaseGridHeader';



const useBaseGridHeader = <T extends unknown>(props: BaseGridHeaderProps<T>) => {
	const { propertyName, filterObject, onSearchValues, onAddFilterValues, onClearFilter, onSorting, onClearSorting } = props;

	
	const filterValues = useMemo(() => {
		if (filterObject && propertyName && filterObject[propertyName]) {
			let visibleValues = filterObject[propertyName].filter(x => x && x.hidden === false);
			let uniqueValuesMap = new Map(visibleValues.map(item => [item.value, item]));
			let uniqueValuesArray = [ ...uniqueValuesMap.values() ];
			return uniqueValuesArray;
		}
		return [];
	},[ filterObject, propertyName ]);


	const activeFilter = useMemo(() =>
		filterValues.some(x => x.checked === false),
	[ filterValues ]);


	const handleSearchValues = useCallback((checkedValues: unknown[]) => {
		if (onSearchValues && propertyName) {
			onSearchValues(propertyName, checkedValues);
		}
	},[ onSearchValues, propertyName ]);


	const handleAddFilterValues = useCallback((showedFilterValues: FilterValue[]) => {
		if (onAddFilterValues && propertyName) {
			onAddFilterValues(propertyName, showedFilterValues);
		}
	},[ onAddFilterValues, propertyName ]);

	
	const handleSorting = useCallback((mode: SortModeEnum) => {
		if (onSorting && propertyName) {
			onSorting(propertyName, mode);
		}
	},[ onSorting, propertyName ]);


	const handleClear = useCallback(() => {
		if (onClearFilter && onClearSorting && propertyName) {
			onClearFilter(propertyName);
			onClearSorting(propertyName);
		}
	},[ onClearFilter, onClearSorting, propertyName ]);


	return [ filterValues, activeFilter, handleSearchValues, handleAddFilterValues, handleSorting, handleClear ] as const;
};

export default useBaseGridHeader;